var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20451 14.6663C4.52261 14.6663 1.53784 11.6815 1.53784 7.99967C1.53784 4.31777 4.52261 1.33301 8.20451 1.33301C11.8864 1.33301 14.8712 4.31777 14.8712 7.99967C14.8712 11.6815 11.8864 14.6663 8.20451 14.6663ZM7.53957 10.6663L12.2536 5.95229L11.3108 5.00949L7.53957 8.78074L5.65398 6.89507L4.71117 7.83794L7.53957 10.6663Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCircleFill);
export default __webpack_public_path__ + "static/media/checkbox-circle-fill.4c31449a.svg";
export { ForwardRef as ReactComponent };